import React, { useState, useEffect, useRef} from 'react';
import { useParams} from 'react-router-dom';
import axios from 'axios';
//import { GanttComponent , DayMarkers, HolidaysDirective, Inject, HolidayDirective } from '@syncfusion/ej2-react-gantt';
import "../assets/css/styles.table.css"
import { DataGrid  } from '@mui/x-data-grid';
import '../App.css';
import Box from '@mui/material/Box';
import { Typography, Modal, 
} from '@mui/material';
import { ColumnDirective, ColumnsDirective, TreeGridComponent,RowDD,Inject , Aggregate, AggregatesDirective } from '@syncfusion/ej2-react-treegrid';
import { Edit, Toolbar, AggregateColumnDirective, AggregateColumnsDirective, AggregateDirective, extendArray   } from '@syncfusion/ej2-react-treegrid';
import VirtualizedSelect from 'react-virtualized-select';
import Button from '@mui/material/Button';
import { dataSourceChanged, getObject } from '@syncfusion/ej2-grids';
import Layout from './Layout.js';
import Helper from './Helper.js';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import ConfirmationButton from '../components/ConfirmationButton'  ;
import PrintPreview from '../components/PrintReviewV3.js';
import DatePicker from 'react-datepicker'; 
import {useEditInvoicesHook} from '../hook/EditInvoicesHook.js'

const EditInvoiceV3 =   () => {
    const { id,id2 } = useParams();
    
    const [treegrid, setTreegrid] = useState([]);

    const {message,setmessage,tipe,settipe,invoiceCode,rev,open,handleClick,isLastId,anchorEl,menuOpen,handleMenuClose,handleRev,handleDefault,
      revRows,revColumns,roleAccess,AddParentTask,handlePreview,persentase,handleTotal,setInvoiceType,setPersentase,setTotal,InvoiceType,pph,setPph,pphValue,
       customer,setCustomer,paymentTermList,handleSelectedPaymentTerm,selectedOptionPaymentTerm,selectedDate,setSelectedDate,selectedDueDate,setSelectedDueDate,
      description,setDescription,rows,editOptions,toolbarOptions,actionBegin,actionComplete,rowDrop,toolbarClick,settings,priceTemplate,TotalTemplate,customAggregateFn,custom,
      custom2,custom3,confirmTaskOpen,AddTask,typeList,setSelectedType,selectedType,partNo,setPartNo,qty,setQty,price,setPrice,confirmDeleteOpen,setConfirmDeleteOpen,taskName,
      handleDeleteConfirmation,treedata,setPphValue,custom1,setOpen,setConfirmTaskOpen
} = useEditInvoicesHook(id,id2,treegrid)
    

const productTypeColTemplate = (props) => {
        if(getObject('product_type', props) == 1){
          return "Material"
        }

        if(getObject('product_type', props) == 2){
          return "Service"
        }

        if(getObject('product_type', props) == 0){
          return ""
        }
        
  };

    return (
      <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
      <div className='pd' style={{position:'relative'}}><b>#{invoiceCode} [Rev.{rev}]</b> 
      <div  style={{position:'absolute', right:0, top:0}}>
                    <div className='text-right' >
                     <Button
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={(evt) => handleClick(evt)}
                        disabled={isLastId}
                      >
                      <MoreVertIcon sx={{ fontSize: 30 }}/>
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={menuOpen}
                        onClose={handleMenuClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >
                        <MenuItem   onClick={() => handleRev('add')} ><AddIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;NEW REVISION</MenuItem>
                        <MenuItem   onClick={() => handleRev('remove')} ><RemoveIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CANCEL REVISION</MenuItem>
                        <MenuItem   onClick={() => handleDefault()} ><CheckCircleIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SET DEFAULT PO</MenuItem>
                      
                      </Menu>
                      
                  </div>
                </div>
  </div>
 
  <div className="pd"  id='dialog-target'>
  <div>
                <div  style={{backgroundColor:"white" }} >
                <h3>Revision History    </h3>
                  <Box sx={{ p: 2,m:0, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3}}>
                    <DataGrid rows={revRows}  columns={revColumns}  className='fonty' getRowId={(row) => row.id} />  
                  </Box>
                </div>
          </div>
           <div style={{display:"flex", width:"100%"}}>
            <div style={{marginTop:5,marginBottom:10, width:"50%"}}>
            <ConfirmationButton   disabled={roleAccess.UPDATE == true ? (isLastId) : !roleAccess.UPDATE} classname='btn btn-primary' text="Do you want save this data?" type="button" title="Save"  onClick={() => AddParentTask()} >
                      UPDATE
            </ConfirmationButton>
            <button onClick={() => handlePreview()} className='btn btn-primary' id="btnPreview" style={{display:'none'}}>SAVE</button> 
                        {/* <button onClick={() => AddParentTask()} className='btn btn-primary' style={{width:150}} disabled={isLastId}>UPDATE</button>  */}
            </div>
            
            </div>
          
           
            <div className="container-form">
              <div className="column-form">
              <label>INV</label>
                  <div style={{display: 'flex'}}>
                    <div className='col-lg-6' >
                      <input
                    type="number"
                    value={persentase}
                    name="address"
                    min ={0}
                    max = {100}
                    onChange={(e) => handleTotal(e.target.value)}
                    className='form-control'
                    required
                    disabled={isLastId}
                 />
                    </div>
                 <div   className='col-lg-6' >
                 <VirtualizedSelect 
                                       options={[{label : 'Percent (%)', value: 'Percent'},{label : 'Nominal (Rp)', value: 'Nominal'}]}
                                       //onChange={(option) => setSelectedOptionPayment(option)}
                                       onChange={   (option) => {setInvoiceType(option.value); setPersentase(0); setTotal(0)}}
                                       value={InvoiceType}
                                       clearable={false}
                                       searchable={true}
                                       required
                                       disabled={isLastId}
                                    />
                 </div>
                 
                  </div> 
              <br></br>
                  <label>PPH (fill with 0 if not using PPh)</label>
                  <div style={{display: 'flex'}}>
                    <div className='col-lg-3' >
                      <input
                    type="number"
                    value={pph}
                    name="pph"
                    min ={0}
                    max = {100}
                    onChange={(e) => setPph(e.target.value)}
                    className='form-control'
                    required
                    disabled={isLastId}
                 />
                </div>
                <div className='col-lg-1' style={{textAlign:'left', paddingTop:9,paddingLeft:0}}>%</div>
                <div className='col-lg-1' style={{textAlign:'left', paddingTop:9,paddingRight:0}}>Rp</div>
                 <div className='col-lg-7' style={{textAlign:'left', paddingLeft:0}}>
                 <input
                    type="number"
                    value={pphValue}
                    name="pph"
                    min ={0}
                    max = {100}
                    onChange={(e) => setPphValue(e.target.value)}
                    className='form-control'
                    required
                    disabled={isLastId}
                 />
                 </div>
                 
                  </div> 
                </div>
                
                <div className="column-form"> 
                <label >INV NO.</label>
                <div style={{display: 'flex'}}>
                     <span style={{fontSize:14}}>{invoiceCode.split('/')[0]}/MS/&nbsp;</span>
                     <input
                        type="text"
                        value={customer}
                        name="inNo"
            
                        onChange={(e) => setCustomer(e.target.value)}
                   // placeholder="Enter the purchase No."
                        className='form-control'
                         style={{width:100, height:25}}
                        required
                        disabled={customer ? true : false}
                       // style={{margin:5}}
                    />&nbsp;
                    <span style={{fontSize:14}}>/ {invoiceCode.split('/')[3]} /{invoiceCode.split('/')[4]} </span>
                </div>
                  
                </div>

          </div>

          < div className="container-form">
                <div className="column-form"> 
                <label >Payment Term</label><hr style={{backgroundColor:'gray',height:0.3}}></hr>
                <VirtualizedSelect
                                        options={paymentTermList}
                                        onChange={(option) => handleSelectedPaymentTerm(option)}
                                        value={selectedOptionPaymentTerm}
                                        clearable={false}
                                        searchable={true}
                                        required
                                       
                                    />
                <div>Date</div>
                <DatePicker 
                    showIcon
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                   // disabled={!roleAccess.UPDATE}
                    dateFormat="dd-MM-yyyy"
                   
                    className="form-control"/>
 
                <div style={{marginTop:10}}>Due Date</div>
                <DatePicker 
                    showIcon
                    selected={selectedDueDate}
                     onChange={(date) => setSelectedDueDate(date)}
                   // disabled={!roleAccess.UPDATE}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"/>
                </div>
                
                <div className="column-form"> 
                <label >Note</label>
                  {/* <input
                   
                    type="text"
                    value={description}
                    name="address"
            
                     onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter the description."
                    className='form-control'
                    fullWidth
                    required
                    disabled={isLastId}
                  /> */}

<textarea
                   
                   type="text"
                   value={description}
                   name="address"
                   rows={10}
                   onChange={(e) => setDescription(e.target.value)}
                   placeholder="Enter the description."
                   className='form-control'
                   fullWidth
                   required
                   disabled={isLastId}
                 />
                </div>
          </div>
          
         
            {/* <div id='tree'>
                <TreeViewComponent fields={fields} allowEditing={true} nodeEdited={editing.bind(this)} allowDragAndDrop={true} nodeDropped={dragdrop.bind(this)} ref={(treeview) => { treeObj = treeview; }} nodeClicked={nodeclicked.bind(this)} nodeCollapsed={collapse.bind(this)} nodeExpanded={expanded.bind(this)} nodeTemplate={nodeTemplate} />
                <ContextMenuComponent id="contentmenutree" target='#tree' items={menuItems} beforeOpen={beforeopen.bind(this)} select={menuclick.bind(this)} ref={(contextmenu) => { menuObj = contextmenu; }}/>
            </div> */}
           
            <div>
              <TreeGridComponent dataSource={rows} treeColumnIndex={1} childMapping='subChild' height='300'   enableCollapseAll={false}   editSettings={editOptions} toolbar={toolbarOptions} ref={g => setTreegrid(g)} actionBegin={actionBegin} actionComplete={actionComplete} allowRowDragAndDrop={true} rowDrop={rowDrop.bind(this)} disabled={isLastId} toolbarClick={toolbarClick} allowTextWrap={true} textWrapSettings={settings}>
                 <ColumnsDirective>
                    {/* <ColumnDirective field='rowNumber' headerText='No' width='70' textAlign='Left'  /> */}
                    <ColumnDirective field='invoice_id' headerText='ID' width='150' textAlign='Right' isPrimaryKey={true}  visible={false}/>
                    <ColumnDirective field='part_no' headerText='Part No.' width='300'/>
                    <ColumnDirective field='descriptions' headerText='Description' width='250'  textAlign='Left' />
                     <ColumnDirective field='unit_name' headerText='Unit' width='100'  textAlign='Right' />
                    <ColumnDirective field='newqty' headerText='Qty' width='130'  textAlign='Right' />
                    <ColumnDirective  headerText='Product Type' width='130'  textAlign='Right' template={productTypeColTemplate} />
                    <ColumnDirective field='price' headerText='Price' width='130'  textAlign='Right' valueAccessor={priceTemplate}/>
                    <ColumnDirective field='total' headerText='Total' width='250' template={TotalTemplate} textAlign='Center'/>
                    <ColumnDirective field='code' headerText='Code' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='rev' headerText='Rev' width='350'  textAlign='Left' visible={false}/>
                    <ColumnDirective field='type' headerText='type' width='350'  textAlign='Left' visible={false}/>
{/*                     
                    <ColumnDirective field='Action 1' headerText='Add Parent' width='120' textAlign='Right'/>
                    <ColumnDirective field='Action 2' headerText='Add Sub' width='100' textAlign='Right'/>
                    <ColumnDirective field='Edit' headerText='Edit Task' width='80' textAlign='Right'/>
                    <ColumnDirective field='Delete' headerText='Delete Task' width='100' textAlign='Right'/> */}
                </ColumnsDirective>
                <AggregatesDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom1}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom' customAggregate={customAggregateFn} footerTemplate={custom}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom2}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                <AggregateDirective showChildSummary={false}>
                    <AggregateColumnsDirective>
                    <AggregateColumnDirective field='total' columnName='total' type='Custom'   footerTemplate={custom3}/>
                     
                    </AggregateColumnsDirective>
                </AggregateDirective>
                </AggregatesDirective>
                <Inject services={[Edit, Toolbar, RowDD, Aggregate]}/>
            </TreeGridComponent>;
            </div>
            
            <Modal
              open={confirmTaskOpen}
              onClose={() => setConfirmTaskOpen(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
          <Box className='modals' >
          {/* <Typography id="modal-modal-title">
            <h4>Detail</h4>
          </Typography> */}
          
          <Typography id="modal-modal-description">
            <form onSubmit={AddTask} role="form">
            <div class="row">
            <div class="col-md-12">
            <label>Type</label>
            <VirtualizedSelect
                         options={typeList}
                         onChange={(option) => setSelectedType(option.value)}
                         value={selectedType}
                        clearable={false}
                        searchable={true}
                         placeholder="Type"
                        required
                    /> 
            </div>
             </div>
          <div class="row">
            <div class="col-md-12">
                <label>Part No</label>
                <input
                      type="text"
                      className="form-control"
                      placeholder="Part No"
                      required
                      value={partNo}
                      onChange={(e) => setPartNo(e.target.value)}
                    />
            </div>
             
         </div>
         {selectedType == 1 && (
            <div>
         
         <div class="row">
            <div class="col-md-6">
                <label>Description</label><br></br>
                <input
                      type="text"
                      className="form-control"
                      placeholder="Description"
                      required
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Qty</label><br></br>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Qty"
                      max={100}
                      min={0}
                      value={qty}
                      onChange={(e) => setQty(e.target.value)}
                      required
                    />

                </div>


                
            </div>
         </div>

         <div class="row">
            <div class="col-md-6">
            <label>Price</label>
            <input
                      type="number"
                      className="form-control"
                      placeholder="Price"
                      max={100}
                      min={0}
                      value={price}
                      onChange={(e) => setPrice(e.target.value)}
                      required
                    />
            </div>
            
         </div>
          
         </div>
)} 
         <hr></hr>
         <div class="row">
            <div class="col-md-12" style={{textAlign:'right'}}>
            <div style={{marginTop:5,marginBottom:5}}>
            <button type="submit" className="btn btn-primary">ADD TASK</button>
                 </div>
            </div>
           
         </div>
         </form>
       
          </Typography>
        </Box>
</Modal>

      <Modal
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modals'  >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <h3>Delete   {taskName}</h3>
          </Typography>
          <Typography id="modal-modal-description">
            <p>Are you sure you want to delete this data?</p>
            <button onClick={handleDeleteConfirmation} className='submit-button'>
              Yes
            </button>
            &nbsp;
            <button
              onClick={() => setConfirmDeleteOpen(false)}
              className='close-button'
            >
              No
            </button>
          </Typography>
        </Box>
      </Modal>  
    </div>
          {/* <PrintPreview id={id} open={open} setopen={setOpen}>
              {treedata}
          </PrintPreview> */}
          <PrintPreview id={id} id2={id2} open={open} setopen={setOpen}>
                            {treedata}
        </PrintPreview>
 </Layout>
       
    );
}
 

export default EditInvoiceV3;